import React, { memo, useState } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button, Dialog, Illustration } from '@node-space/ui-components'
import { ActionIds, WalletTypes } from 'types/types'
import {
  massPayoutStepAtom,
  modalAtom,
  totalNumberOfPayoutsAtom,
  totalPaymentsAtom,
  walletTypeAtom,
} from '../atoms/massPayoutAtoms'
import { MassPayoutsUpload } from '../pages/MassPayoutsUpload'
import { MassPayoutSteps, ModalVariant } from '../types'

const MassPayoutModal = () => {
  const { t } = useTranslation()
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const totalPayments = useAtomValue(totalPaymentsAtom)
  const setMassPayoutStep = useSetAtom(massPayoutStepAtom)
  const setAction = useSetAtom(actionAtom)
  const [modal, setModal] = useAtom(modalAtom)
  const totalNumberOfPayouts = useAtomValue(totalNumberOfPayoutsAtom)
  const walletType = useAtomValue(walletTypeAtom)

  const cryptoPayout = walletType === WalletTypes.CRYPTO

  const handleDoneClick = () => {
    setModal({ isOpen: false })
  }

  const handleUploadNewFile = () => {
    setAction({
      actionId: ActionIds.MASSPAYOUTS_UPLOAD,
      header: t('massPayouts.createNewMassPayout'),
      onClose: () => {
        setIsSheetOpen(false)
        setMassPayoutStep(MassPayoutSteps.FORM)
      },
    })
    setIsSheetOpen(true)
    setModal({ isOpen: false })
  }

  const numberOfPayments = cryptoPayout ? (totalNumberOfPayouts ?? totalPayments) : totalPayments

  const MassPayoutModalVariant = ({ modalVariant }) => {
    if (modalVariant === ModalVariant.DRAFT)
      return (
        <Dialog
          open
          title={t('massPayouts.draftOutstanding')}
          Illustration={<Illustration name="HourGlassLow" />}
          onClose={handleDoneClick}
          ActionButtons={[
            <Button key="uploadNewFile" onClick={handleUploadNewFile}>
              {t('massPayouts.uploadNewFile')}
            </Button>,
            <Button key="continueEditing" onClick={handleDoneClick} variant="secondary">
              {t('massPayouts.continueEditing')}
            </Button>,
          ]}
        >
          <Box data-testid="modal-draft">
            <p className="text-foreground-prominent text-body-regular text-center">
              {t('massPayouts.outstandingPayments', {
                numberOfPayments: numberOfPayments,
              })}
            </p>
          </Box>
        </Dialog>
      )
  }

  return (
    <>
      {modal?.isOpen && <MassPayoutModalVariant modalVariant={modal?.variant} />}
      <MassPayoutsUpload isOpen={isSheetOpen} onClose={() => setIsSheetOpen(false)} />
    </>
  )
}

export default memo(MassPayoutModal)
